export default __webpack_public_path__ + "static/media/card3200.d538204a.jpg";